import OneMindFeatures from "@/components/oneMindFeatures";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const WhyOnemind = () => {
  return <OneMindFeatures {...WHY_ONEMIND_CONSTANTS} />;
};

export default WhyOnemind;
